var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2v-7.671c.406.501.917.913 1.5 1.203V18a.5.5 0 00.5.5h3.441a.76.76 0 01.029-.03l3.98-3.981a2.75 2.75 0 013.175-.515l1.421.71a1.25 1.25 0 001.443-.234l2.98-2.98.031-.028V6a.5.5 0 00-.41-.492L20 5.5H9.532A4.518 4.518 0 008.33 4H20zm.5 9.56l-1.95 1.951a2.75 2.75 0 01-3.175.515l-1.421-.71a1.25 1.25 0 00-1.443.234L9.56 18.5H20a.5.5 0 00.492-.41L20.5 18v-4.44zM5.5 4a3.5 3.5 0 012.717 5.706L9.6 11.55a.75.75 0 11-1.2.9l-1.356-1.808A3.5 3.5 0 115.5 4zm0 1.5a2 2 0 100 4 2 2 0 000-4z",
    fill: "currentColor"
  })));
}

export default SvgImageSearch;